/** @format */
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { numberUtils } from 'common-typescript';
import { ExternalAttainedStudyAttachments } from 'common-typescript/types';
import { ModalService } from 'sis-common';
import { EditApplicationAttachmentsModalComponent, FileItem } from 'sis-components';

@Component({
    selector: 'app-application-attachments',
    templateUrl: './application-attachments.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ApplicationAttachmentsComponent {
    @Input() initialAttachments: FileItem[] = [];
    @Input() externalAttainedStudyAttachments: ExternalAttainedStudyAttachments[] = [];

    @Output() updateAttachments = new EventEmitter<FileItem[]>();

    constructor(private modalService: ModalService) {}

    editAttachments(): void {
        const componentRef = this.modalService.open(
            EditApplicationAttachmentsModalComponent,
            {
                previouslyAddedFiles: this.initialAttachments,
                externalAttachments: this.externalAttainedStudyAttachments,
            },
            { size: 'sm' },
        );

        componentRef.result
            .then(data => {
                this.initialAttachments = data;
                this.updateAttachments.emit(this.initialAttachments);
            })
            .catch(() => {}); // The modal was dismissed => do nothing
    }

    readableFileSizeString(number: number) {
        return numberUtils.readableFileSizeString(number);
    }
}
